import { Injectable, Optional } from '@angular/core';
import { HttpService } from '../../core/services/http/http.service';
import { ShoppingCart, ShoppingConfig } from '../../shared/models/shopping';
import { ParmedApiService as ParmedApi } from '../../core/api/parmed-api.service';
import { UserService } from '../../core/services/user.service';
import { PublisherService } from '../../core/services/publisher.service';
import { AddToCartRequest } from '../../shared/models/add-to-cart';
import { AppUtilService } from '../../core/utils/app-util.service';
import { CurrencyPipe } from '@angular/common';
import {
  CsosHistoryRequest,
  CsosOrder,
  Order,
  OrderDetail
} from '../../shared/models/order';
import { ExportExcelService } from '../../core/services/export-excel.service';
import { Workbook } from 'exceljs';
import { StaticConstants } from '../../core/constants/static.constants';
import { OrderAccount } from './order.constant';
import {
  UserProperty,
  RequestHeaders,
  CacheConstant,
  AccountProperty
} from '../../core/constants/app.constant';
import { Observable, of } from 'rxjs';
import { BaseComponent } from '../../app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { execute, executePut } from '../../modules/products/products.service-helper';
import 'rxjs/add/operator/map';
import { StaticService } from '../../core/services/static/static.service';
import { mapExecute } from './order.service-helper';
import { switchMap, map } from 'rxjs/operators';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { HttpHeaders } from '@angular/common/http';
import { CreditCheck } from '../../shared/models/order';
import { AppConfigService } from '../../core/services/init/app-config.service';

@Injectable()
export class OrderService extends BaseComponent {
  creditCheckResponse: CreditCheck;
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  /***************Constructor***************/
  constructor(
    private api: ParmedApi,
    private http: HttpService,
    private userService: UserService,
    private exportService: ExportExcelService,
    private currency: CurrencyPipe,
    deviceDetectorService: DeviceDetectorService,
    private staticService: StaticService,
    private cache: AppCacheService,
    private appConfig: AppConfigService
  ) {
    super(deviceDetectorService, cache, appConfig);
  }
  /***************Constructor***************/

  /***************Service Methods***************/

  getOpenOrders() {
    return execute(
      this.http,
      this.api.Order.GET_ORDERS_URL,
      this.userService.getDefaultAccSoldtoShipToObj(), undefined, this.appConfig
      );
  }

  get(request: ShoppingCart) {
    return execute(this.http,  this.api.Order.VIEW_ORDER_URL,   Object.stringify(request), {ignoreLoadingBar :''}, this.appConfig);
  }

  getCount() {
    //console.log('getcount');
    console.log("DefaultSoldtoshiptoObj",this.userService.getDefaultAccSoldtoShipToObj());
    console.log("Order Item Count API",this.api.Order.GET_ORDER_COUNT_URL);
    const userDetail = this.cache.get(CacheConstant.User_Auth_Detail);
    console.log("shipToNum",userDetail.defaultShipToNumber,"soldToNum",userDetail.defaultSoldToNumber);
    return this.http.get(this.api.Order.GET_ORDER_COUNT_URL+'?shipToNum='+userDetail.defaultShipToNumber+'&soldToNum='+userDetail.defaultSoldToNumber);
   // return execute(this.http, this.api.Order.GET_ORDER_COUNT_URL, this.userService.getDefaultAccSoldtoShipToObj(), PublisherService, this.appConfigService);
  }

  cartCountUpdate(){
    this.getCount().subscribe((response: any) => {
      if (response && !response.hasError) {
        PublisherService.notifyCartCountUpdated(response.count);
      }
    });
  }

  getHistory(
    pageSize: number,
    pageNumber: number,
    filterDate: string,
    filterToDate: string,
    itemId: string,
    sortField: string,
    sortDirection: string
  ) {
    //const defaultSoldtoShipto = this.userService.getDefaultAccSoldtoShipToObj();
    const userDetail = this.cache.get(CacheConstant.User_Auth_Detail);
    //console.log(userDetail);
    const historyRequestObj = {
      shipToNum: userDetail.defaultShipToNumber,
      soldToNum: userDetail.defaultSoldToNumber,
      top: pageSize,
      skip: (pageNumber - 1) * pageSize,
      filterDate: filterDate,
      filterToDate: filterToDate,
      itemId: itemId,
      sortBy: sortField,
      sortDirection: sortDirection
    };
    let options = this.createRequestOptionsWithAccess();
    return this.http.post(this.api.Order.GET_ORDER_HISTORY_URL, historyRequestObj, {headers: options});
  }

  createRequestOptionsWithAccess() {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-api-key": this.envProperties.apiKey,
      "access-token": this.cache.get(CacheConstant.Auth_Tokens)["access-token"]
    });
    return headers;
  }

  getHistoryDetail(orderNum: number) {
    let detailObject = { orderNum: orderNum };
    detailObject = Object.assign(
      detailObject,
      this.userService.getDefaultAccSoldtoShipToObj()
    );
    // console.log('getHistoryDetail');
    let options = this.createRequestOptionsWithAccess();
    return this.http.post(this.api.Order.GET_ORDER_HISTORY_DETAIL_URL, detailObject, {headers: options});
  }

  getHistoryDetailFacts(invoiceNumber: Array<string>) {
    let detailObject = { invoiceNumber: invoiceNumber };
    
    return this.http.post(
      this.api.Order.GET_ORDER_HISTORY_DETAIL_FACTS_URL,
      detailObject,
      AppUtilService.getHttpDefaultOptions()
    );
  }

  getTrackingDetails(trackingObject: Array<any>) {
    return this.http.post(
      this.api.Order.GET_ORDER_TRACKING_DETAIL_URL,
      trackingObject
    );
  }

  update(order: Order) {
    return execute(this.http, this.api.Order.UPDATE_ORDER_URL,  Object.stringify(order), undefined, this.appConfigService);
  }
  updateRejectedOrder(orderNum:number)
  {
  return execute(this.http, this.api.Order.UPDATE_Rejected_ORDER_URL+'?orderNumber='+orderNum, undefined, this.appConfigService);
  }
  getCart(request: any) {
    const defaultAccount = this.userService.getDefaultAccount();
    request.userDetailNum = defaultAccount.userDetailNum;
    return execute(this.http, this.api.Order.VIEW_CART_URL, request, undefined, this.appConfigService);
  }

  addToCart(orders: any, order?: any) {
    const searchTracker = this.cache.get(
      CacheConstant.Search_Tracker
    );

    if (searchTracker) {
      searchTracker.addtoCart = 1;
    }

    const addToCartRequest: AddToCartRequest = {
      orderHeaderVO: {
        orderDetails: orders,
        orderNum: order ? order.orderNum : null,
        soldToNum: null,
        shipToNum: null,
        versionNum: order ? order.versionNum : null
      },
      searchTracker: searchTracker,
    };

    addToCartRequest.orderHeaderVO = Object.assign(
      addToCartRequest.orderHeaderVO,
      this.userService.getDefaultAccSoldtoShipToObj()
    );
    return execute( this.http, this.api.Order.ADD_TO_CART_URL, addToCartRequest, undefined, this.appConfigService);
  }

  getCsosSubmittedOrders(csosOrderNum?: number) {
    return this.http.post(this.api.Order.GET_CSOS_SUBMITTED_ORDER_DETAIL_URL, {
      csosOrderNum: csosOrderNum
    });
  }

  getCsosOrderHistory(request: CsosHistoryRequest) {
    const defaultAccount = this.userService.getDefaultAccSoldtoShipToObj();
    request.shipToNum = defaultAccount.shipToNum;
    request.soldToNum = defaultAccount.soldToNum;
    return this.http.post(
      this.api.Order.GET_SUBMITTED_CSOS_ORDERS_URL,
      JSON.stringify(request)
    );
  }

  getCsosOrderDetails(request: CsosHistoryRequest) {
    const defaultAccount = this.userService.getDefaultAccSoldtoShipToObj();
    request.shipToNum = defaultAccount.shipToNum;
    request.soldToNum = defaultAccount.soldToNum;
    return this.http.post(
      this.api.Order.GET_CSOS_SUBMITTED_ORDER_DETAILS_URL,
      request
    );
  }

  saveCsosSubmittedOrders(submitCsosOrders) {
    return this.http.post(
      this.api.Order.SAVE_CSOS_SUBMITTED_ORDER_DETAILS_URL,
      submitCsosOrders
    );
  }

  submit(submitOrders: any, nativeApp?: string) {
    let userAgentType: string;

    if (nativeApp) {
      userAgentType = nativeApp;
    } else if (this.isMobileDevice()) {
      if (AppUtilService.isMobileApp()) {
        if (AppUtilService.isApple()) {
          userAgentType = 'iPhone App';
        } else {
          userAgentType = 'Android App';
        }
      } else {
        userAgentType = 'Mobile';
      }
    } else {
      userAgentType = 'Web';
    }

    submitOrders.userAgentType = userAgentType;

    return execute( this.http, this.api.Order.ORDER_SUMMARY_URL, submitOrders, undefined, this.appConfig).pipe(map((response: any) => {
        if (!response || !response.hasError) {
          this.cartCountUpdate();
        }
        return response;
      }));
  }

  checkout(checkOutNonC2Request) {
    return execute(this.http, this.api.Order.CHECK_OUT_ORDERS_URL, checkOutNonC2Request, undefined, this.appConfigService);  
  }

  getUniqueTrackingNum() {
    return execute(
      this.http,
      this.api.Order.GET_UNIQUE_TRACKING_NUMBER_URL,
      this.userService.getDefaultAccSoldtoShipToObj(), undefined, this.appConfig
    );
  }

  certPasswordEncrypt(plainPassword: string) {
    return execute(
    this.http,
    this.api.Order.CERT_PWD_ENCRYPT_URL,
    plainPassword,
    {
      headers: { 'Content-Type': 'text/plain' }
    }, this.appConfig
    );
  }

  signCSOSOrder(apiRequest: string, certPassword: string) {
    // Shipto to be replaced with DEA number
    const defaultAccount = this.userService.getDefaultAccountMasterData();

    let userName: string = this.userService.getProperty(UserProperty.Identification);
    userName = userName.toString().toLowerCase();
    const defaultOptions = AppUtilService.getHttpDefaultOptions();
    defaultOptions.headers[RequestHeaders.ContentType.toString()] =
      'application/json';
    defaultOptions.headers['certPassword'] = certPassword;
    defaultOptions.headers['APIKey'] = this.envProperties.axWayApiKey;
    defaultOptions.headers['Accept'] = '*/*';
    defaultOptions.headers['Accept-Language'] = 'en-US,en;q=0.8';
    defaultOptions.headers['Cache-Control'] = 'no-cache';

    return executePut(
      this.http,
      this.envProperties.axWayApiUrl + '/' + userName + '/' + defaultAccount.deanum,
      apiRequest,
      defaultOptions,
      this.appConfig
    );
  }

  getReturnSearch(searchText: string) {
    const defaultAccount = this.userService.getDefaultAccSoldtoShipToObj();
    const request = {
      searchValue: searchText,
      shipToNum: defaultAccount.shipToNum
    };
    return this.http.post(this.api.Order.PRODUCT_RETURN_SEARCH_URL, request);
    //return this.http.post("http://localhost:8159/order/return/search", request);
  }

  getReturnSearchSynchronous(searchText: string):Promise<any>{
    return this.getReturnSearch(searchText).toPromise();
  }

  getItemsSerializationStatus(itemNum: number,returnReason : boolean) {
    let request ;
    if(!returnReason){
       request = {
        itemNum: itemNum,
        invoiceNum: "",
        invoiceDate:"",
        quantity :"",
        desc:"",
        returnReason:returnReason
      };
    }else{
      request = {
        itemNum: "",
        invoiceNum: "",
        invoiceDate:"",
        quantity :"",
        desc:"",
        returnReason:returnReason
      };
    }
  // let itemSerUrl = "http://localhost:8159/order/return/isItemSerialized"
    return this.http.post(this.api.Order.GET_ITEM_SERIALIZATION_URL, request);
   // return this.http.post(itemSerUrl, request);
  }


  // getItemsSerializationStatus(itemNum: number) {
    
  //      let request = {
  //       itemNum: itemNum,
  //       invoiceNum: "",
  //       invoiceDate:"",
  //       quantity :"",
  //       desc:"",
  //   }
  //  //let itemSerUrl = "http://localhost:8159/order/return/isItemSerialized"
  //   return this.http.post(this.api.Order.GET_ITEM_SERIALIZATION_URL, request);
  //   //return this.http.post(itemSerUrl, request);
  // }

  postProductReturn(returnRequest) {
    return this.http.post(this.api.Order.RETURN_PRODUCT_URL, returnRequest, {
      observe: 'response'
    });
  }

  getInvoiceData() {
    // const defaultAccount = this.userService.getDefaultAccSoldtoShipToObj();
    const defaultAccount = this.userService.getDefaultAccount();
    
    let accountNumForInvoices = defaultAccount.accountShipToNum;
    if(defaultAccount.canPayFlg) {
      accountNumForInvoices = defaultAccount.accountSoldToNum;
    }
    
    const data = {
      customer: accountNumForInvoices,
      documentType: 'IN,CM,DM,RC,OA,SC'
    };
    return this.http.post(this.api.Order.GET_INVOICE_DATA_URL, data);
  }

  downloadInvoice(invoiceNum) {
    return this.http.get(this.api.Order.DOWNLOAD_INVOICE_URL + invoiceNum, { responseType: 'blob' });
  }  
  
  downloadInvoiceBase64(invoiceNum, soldToNum) {
    return this.http.get(this.api.Order.DOWNLOAD_INVOICE_BASE64_URL + soldToNum + '/'+ invoiceNum);
  }  
  
  public getCreditCardsList() {
    const payerId = this.userService.getDefaultAccount()[
      AccountProperty.PayerId
    ];
    return this.http.post(this.api.Config.GET_CREDIT_CARDS_URL, {
      payerId: payerId
    });
  }

  payInvoice(inputData){
    const defaultAccount = this.userService.getDefaultAccount();
    
    let accountNumForInvoices = defaultAccount.accountShipToNum;
    if(defaultAccount.canPayFlg) {
      accountNumForInvoices = defaultAccount.accountSoldToNum;
    }

    inputData.customer = accountNumForInvoices;
    return this.http.post(this.api.Order.PAY_INVOICE_URL,inputData);
  }
  /***************Service Methods***************/

  /***************Helper Methods***************/

  export(orders: CsosOrder[]) {
    const fileName = 'CSOSOrderHistory';
    const summarySheetName = 'Order Summary';

    const csosWorkbook = this.exportService.createWorkbook();
    this.addSummaryWorksheet(csosWorkbook, orders, summarySheetName);

    orders.forEach(order => {
      this.addDetailWorksheet(csosWorkbook, order, summarySheetName);
    });

    this.exportService.export(csosWorkbook, fileName);
  }

  getOrderShoppingConfig(): ShoppingConfig {
    const minOrderValuePreference = this.staticService.appPreference.get(
      StaticConstants.AppPreference.DefaultMinOrderValue
    );
    const c2OrderValuePreference = this.staticService.appPreference.get(
      StaticConstants.AppPreference.C2MinOrderValue
    );
    const mixOrderValuePreference = this.staticService.appPreference.get(
      StaticConstants.AppPreference.MixOrderMinValue
    );
    const hawaiiOrderValuePreference = this.staticService.appPreference.get(
      StaticConstants.AppPreference.HawaiiMinOrderValue
    );
    const alaskaOrderValuePreference = this.staticService.appPreference.get(
      StaticConstants.AppPreference.AlaskaMinOrderValue
    );
    const accountNonC2BypassPreference = this.staticService.appPreference.get(
      StaticConstants.AppPreference.AccountNonC2ByPassValue
    );

    return {
      defaultMinOrderValue: minOrderValuePreference.preferenceValue.toNumber(),
      C2MinOrderValue: c2OrderValuePreference.preferenceValue.toNumber(),
      mixMinOrderValue: mixOrderValuePreference.preferenceValue.toNumber(),
      hawaiiMinOrderValue: hawaiiOrderValuePreference.preferenceValue.toNumber(),
      alaskaMinOrderValue: alaskaOrderValuePreference.preferenceValue.toNumber(),
      accountNonC2BypassValue: accountNonC2BypassPreference.preferenceValue.toNumber()
    };
  }

  setOrderConfig(order: Order) {
    const minOrderValue = this.getOrderMinValue(order);
    const isCombinedOrder = this.isCombinedOrder(order);
    
    order.config = {
      hasFailedPriceProduct:
        order.orderDetails.find(product => product.currentPrice <= 0) !==
        undefined,
      hasNotAvailableProduct: false,
      hasZeroQuantityOrder: false,
      hasSelectedOrder: false,
      opened: false,
      selectAll: false,
      loading: true,
      hasChanges: false,
      hasTax: order.tax > 0,
      hasStateTax: order.stateTax > 0,
      disableC2Checkout: false,
      disableNonC2Checkout: false,
      disableMajorCheckout: false,
      disableRugbyCheckout: false,
      disableCheckoutAll: false,
      isLowAmountOrder: order.total < minOrderValue,
      couponApplicable: (order.isCouponApplicable != undefined) ? order.isCouponApplicable : true,
      minOrderValue: minOrderValue,
      isCombinedOrder : isCombinedOrder
    };

    order.orderDetails.forEach(detail => {
      detail.config = {
        isAvailable: true,
        priceChanged: false,
        hasChanges: false,
        selectedFavList: ''
      };
      this.getProductInventory(order, detail);
      detail.backOrderQuantity =  detail.orderQuantity- detail.availableQuantity;
    });

    order.discount = Math.abs(order.discount);
    order.priceChangedProducts = this.getPriceChangedProducts(order);
  }

  getProductInventory(order: Order, product: OrderDetail) {
    /**
     * Added scenario to check item which is deleted from database after being added to cart.
     * So display not available message to user for this scenario.
     */
    if (!product.brandName && !product.productDesc) {
      product.showQuantityWarning = true;
      product.config.isAvailable = false;
      order.config.hasNotAvailableProduct = true;
      product.quantityWarningText = 'Not Available';
    }

    //-------------------
    product.quantityWarningText = product.allocationCase;

    switch(product.quantityWarningText) {
      case 'Not Available':
        product.showQuantityWarning = true;
        product.config.isAvailable = false;
        order.config.hasNotAvailableProduct = true;
        break;
      case 'Allocation':
        order.config.hasZeroQuantityOrder = true;
        product.showQuantityWarning = true;
        break;
      case 'Low Stock':
        product.showQuantityWarning = true;
        if (product.availableQuantity === 0) {
          order.config.hasZeroQuantityOrder = true;
        }
    }
  }

  hasProducts(order: Order, checkC2Product: boolean) {
    return order.orderDetails.find(
      product =>
        product.isCSOS !== undefined &&
        product.isCSOS.toBoolean() === checkC2Product
    ) !== undefined
      ? true
      : false;
  }

  hasMajorProducts(order: Order) {
    return order.orderDetails.find(
      product =>
        product.labelType !== undefined &&
        product.labelType === 'M'
    ) !== undefined
      ? true
      : false;
  }

  hasRugbyProducts(order: Order) {
    return order.orderDetails.find(
      product =>
        product.labelType !== undefined &&
        product.labelType === 'R'
    ) !== undefined
      ? true
      : false;
  }

  removeUIProperties(order: Order) {
    delete order.config;
    delete order.ordersDataSource;
    delete order.priceChangedProducts;
  }

  filterOrdersByType(orders: Array<Order>, isCsos: Boolean) {
    return orders.filter(
      o =>
        o.orderDetails.find(detail => detail.isCSOS.toBoolean() === isCsos) !==
        undefined
    );
  }


  /***************Helper Methods***************/

  /***************Private Methods***************/
  private isCombinedOrder(order: Order): boolean {
    let isCombined: boolean = false;
    const hasC2Product = this.hasProducts(order, true);
    const hasNonC2Product = this.hasProducts(order, false);

    if(hasC2Product && hasNonC2Product) {
      isCombined = true;
    }

    return isCombined;
  }

  private getOrderMinValue(order: Order): number {
    const shoppingConfig = this.getOrderShoppingConfig();
    const defaultAccountMasterDetails: any = this.userService.getDefaultAccountMasterData();

    const hasC2Product = this.hasProducts(order, true);
    const hasNonC2Product = this.hasProducts(order, false);

    let minOrderValue: number = shoppingConfig.defaultMinOrderValue;
    
    if (hasNonC2Product) {

      const accountState = defaultAccountMasterDetails.state;
      switch (accountState.toString().toUpperCase()) {
        case OrderAccount.Hawaii:
          minOrderValue = shoppingConfig.hawaiiMinOrderValue;
          break;

        case OrderAccount.Alaska:
          minOrderValue = shoppingConfig.alaskaMinOrderValue;
          break;

        default:
          break;
      }

      if (defaultAccountMasterDetails.isBypassOrderMinNonC2.toBoolean()) {
        minOrderValue = shoppingConfig.accountNonC2BypassValue;
      }

    } else {
      
      minOrderValue = shoppingConfig.C2MinOrderValue;
        
    }

    return minOrderValue;
  }

  private getPriceChangedProducts(order: Order): string {
    const priceChangedProducts: number[] = [];
    order.orderDetails
      .filter(
        product =>
          product.currentPrice > 0 && product.currentPrice !== product.unitPrice
      )
      .forEach(product => {
        priceChangedProducts.push(product.itemId);
        product.config.priceChanged = true;
      });
    return priceChangedProducts.join(', ');
  }

  private addSummaryWorksheet(
    workbook: Workbook,
    orders: Array<CsosOrder>,
    summarySheetName: string
  ) {
    const summaryColumns = this.getCsosHistoryExportColumns();
    const summarySheet = this.exportService.addWorkSheet(workbook, {
      name: summarySheetName,
      options: null,
      style: null,
      columnConfig: { bold: true },
      columns: summaryColumns,
      rows: this.getCsosOrderHistoryExportRows(orders)
    });

    orders.forEach((order, index) => {
      const cellIndex = index + 2;
      const csosOrderNumCell = summarySheet.getCell('A' + cellIndex) as any;
      csosOrderNumCell.value = {
        text: order.uniqueTrackingNum,
        hyperlink: this.getExcelHyperlink(order.csosOrderNum.toString())
      };
      csosOrderNumCell.font = {
        color: { argb: 'FF0000EE' },
        underline: true
      };
    });
  }

  private addDetailWorksheet(
    workbook: Workbook,
    order: CsosOrder,
    summarySheetName: string
  ) {
    const detailColumns = this.getCsosDetailExportColumns();
    const worksheet = this.exportService.addWorkSheet(workbook, {
      name: order.csosOrderNum.toString(),
      options: null,
      style: null,
      columnConfig: null,
      rows: null,
      columns: null
    });

    const summaryCell = worksheet.getCell('A1');
    summaryCell.value = {
      text: 'Back To Summary',
      hyperlink: this.getExcelHyperlink(summarySheetName)
    };

    worksheet.mergeCells(1, 1, 0, detailColumns.length);
    summaryCell.alignment = {
      vertical: 'middle',
      horizontal: 'centerContinuous'
    };
    summaryCell.font = {
      color: { argb: 'FF0000EE' },
      underline: true
    };

    this.exportService.addColumns(worksheet, {
      style: null,
      columnConfig: { bold: true },
      columns: detailColumns
    });

    this.exportService.addRows(
      worksheet,
      this.getCsosOrderDetailExportRows(order)
    );
  }

  private getCsosHistoryExportColumns() {
    return [
      {
        header: 'CSOS Order Number',
        key: 'uniqueTrackingNum',
        width: 19,
        style: { alignment: { horizontal: 'left', vertical: 'middle' } }
      },
      {
        header: 'Order Number',
        key: 'csosOrderNum',
        width: 15,
        style: { alignment: { horizontal: 'left', vertical: 'middle' } }
      },
      {
        header: 'Created Date',
        key: 'createdDate',
        width: 13,
        style: { alignment: { horizontal: 'left', vertical: 'middle' } }
      },
      {
        header: 'Total',
        key: 'total',
        width: 9,
        style: { alignment: { horizontal: 'right', vertical: 'middle' } }
      }
    ];
  }

  private getCsosDetailExportColumns() {
    return [
      {
        header: 'Line Number',
        key: 'orderLineNum',
        width: 13,
        style: { alignment: { horizontal: 'center', vertical: 'middle' } }
      },
      {
        header: 'Invoice Number',
        key: 'invoiceNum',
        width: 15,
        style: { alignment: { horizontal: 'left', vertical: 'middle' } }
      },
      {
        header: 'Quantity',
        key: 'orderQuantity',
        width: 8,
        style: { alignment: { horizontal: 'center', vertical: 'middle' } }
      },
      {
        header: 'Package Quantity',
        key: 'packQuantity',
        width: 16,
        style: { alignment: { horizontal: 'center', vertical: 'middle' } }
      },
      {
        header: 'NDC',
        key: 'ndc',
        width: 12,
        style: { alignment: { horizontal: 'left', vertical: 'middle' } }
      },
      {
        header: 'Description',
        key: 'itemName',
        width: 33,
        style: { alignment: { horizontal: 'left', vertical: 'middle' } }
      },
      {
        header: 'Receive Date',
        key: 'receivedStp',
        width: 12,
        style: { alignment: { horizontal: 'left', vertical: 'middle' } }
      },
      {
        header: 'Receive Quantity',
        key: 'receivedQuantity',
        width: 16,
        style: { alignment: { horizontal: 'center', vertical: 'middle' } }
      }
    ];
  }

  private getCsosOrderHistoryExportRows(orders: Array<CsosOrder>) {
    const rows: Array<any> = [];

    orders.forEach(order => {
      rows.push({
        uniqueTrackingNum: order.uniqueTrackingNum,
        csosOrderNum: order.csosOrderNum,
        createdDate: order.createdDate,
        total: this.currency.transform(order.total)
      });
    });

    return rows;
  }

  private getCsosOrderDetailExportRows(order: CsosOrder) {
    const rows: Array<any> = [];

    order.csosOrderDetailsList.forEach(detail => {
      const receivedQuantity = detail.receivedStp
        ? detail.receivedQuantity
        : detail.receivedQuantity || null;
      rows.push({
        orderLineNum: detail.orderLineNum,
        invoiceNum: detail.invoiceNum,
        orderQuantity: detail.orderQuantity,
        packQuantity: detail.packQuantity,
        ndc: detail.ndc,
        itemName: detail.itemName,
        receivedStp: detail.receivedStp,
        receivedQuantity: receivedQuantity
      });
    });

    return rows;
  }

  private getExcelHyperlink(
    sheetName: string,
    @Optional() cell: string = 'A1'
  ) {
    return "#'" + sheetName + "'!" + cell;
    // '#\'' + sheetName + '\'!' + cell;
  }
  uploadMedia(mediaData) {
    return this.http.post(this.api.Order.MEDIA_UPLOAD_URL, mediaData);
  }

  serializationCheck(inputData,isDscsaReturnMockDataFlagOn:boolean): Observable<any>{
   //let orderAPI = "http://localhost:8159/order/return/serialNumberCheck"
   //isDscsaReturnMockDataFlagOn needs to be removed once DSCSA data is avlbl
    if(isDscsaReturnMockDataFlagOn)
      return of(this.Api1Mock(inputData));
    return this.http.post(this.api.Order.SERIAL_NUMBER_CHECK_URL,inputData);
    //return this.http.post(orderAPI,inputData);
  }

  serializationCheckSynchronous(inputData,isDscsaReturnMockDataFlagOn:boolean) :Promise<any>{
    if(isDscsaReturnMockDataFlagOn)
      return of(this.Api1Mock(inputData)).toPromise();
    return this.http.post(this.api.Order.SERIAL_NUMBER_CHECK_URL,inputData).toPromise();
  }
  /***************Private Methods***************/
  Api1Mock(serialPayload){
 
    let shiptoParty = serialPayload.shiptoParty;
    let material = serialPayload.material;
    let serialNumberRequest = serialPayload.serialNumber;
    let api1Response;
 
    let mockData = [
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "3631", serialNumberQty: 0, invoiceNumber: "7224485166",itemId:"3708997", correctShipToParty: "",errorCode:"9008",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"},
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "3632", serialNumberQty: 4, invoiceNumber: "7224485166",itemId:"1000363", correctShipToParty: "",errorCode:"0",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"},
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "3633", serialNumberQty: 0, invoiceNumber: "7224485166",itemId:"1000363", correctShipToParty: "" ,errorCode:"0",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"},
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "3634", serialNumberQty: 0, invoiceNumber: "7224485166",itemId:"1000363", correctShipToParty: "" ,errorCode:"0",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"},
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "3635", serialNumberQty: 1, invoiceNumber: "7224485166", itemId:"1000363",correctShipToParty: "",errorCode:"0",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"},
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "3636", serialNumberQty: 1, invoiceNumber: "7224485166",itemId:"1000363", correctShipToParty: "",errorCode:"0",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"},
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "3645", serialNumberQty: 1, invoiceNumber: "7224485166",itemId:"1000363", correctShipToParty: "" ,errorCode:"0",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"},
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "3646", serialNumberQty: 0, invoiceNumber: "7224485166",itemId:"1000363", correctShipToParty: "" ,errorCode:"0",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"},
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "3647", serialNumberQty: 0, invoiceNumber: "7224485166",itemId:"1000363", correctShipToParty: "" ,errorCode:"0",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"}, 
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "3648", serialNumberQty: 0, invoiceNumber: "7224485166",itemId:"1000363", correctShipToParty: "" ,errorCode:"0",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"}, 
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "3649", serialNumberQty: 0, invoiceNumber: "7224485166",itemId:"1000363", correctShipToParty: "" ,errorCode:"0",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"},
     



      {shiptoParty: "2050000002", material: "1000363", serialNumber: "36315", serialNumberQty: 4, invoiceNumber: "3223551779",itemId:"1000363", correctShipToParty: "",errorCode:"0",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"},
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "36325", serialNumberQty: 1, invoiceNumber: "3223551779",itemId:"1000363", correctShipToParty: "",errorCode:"5003",error:""},
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "36335", serialNumberQty: 2, invoiceNumber: "3223551779",itemId:"1000363", correctShipToParty: "" ,errorCode:"5009",error:""},
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "36345", serialNumberQty: 5, invoiceNumber: "3223551779",itemId:"1000363", correctShipToParty: "" ,errorCode:"5004",error:""}, 
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "36355", serialNumberQty: 1, invoiceNumber: "3223551779", itemId:"1000363",correctShipToParty: "",errorCode:"5016",error:""},
      {shiptoParty: "2050000002", material: "1000363", serialNumber: "36365", serialNumberQty: 2, invoiceNumber: "3223551779",itemId:"1000363", correctShipToParty: "",errorCode:"5017",error:""},
 


      {shiptoParty: "2050000002", material: "1489731", serialNumber: "1621", serialNumberQty: 3, invoiceNumber: "4223551779",itemId:"1489731", correctShipToParty: "",errorCode:"0",error:"",materialGTIN:"123456",lotNumber:"2",expirationDate:"05/20/2025"},
      {shiptoParty: "2050000002", material: "1489731", serialNumber: "1622", serialNumberQty: 3, invoiceNumber: "4223551779", itemId:"1489731",correctShipToParty: "",errorCode:"5061",error:""},
      {shiptoParty: "2050000002", material: "1489731", serialNumber: "1633", serialNumberQty: 3, invoiceNumber: "4223551779", itemId:"1489731",correctShipToParty: "",errorCode:"5061",error:""},
 
      {shiptoParty: "2050000002", material: "1489731", serialNumber: "123", serialNumberQty: 2, invoiceNumber: "5223551779",itemId:"1489731", correctShipToParty: "",errorCode:"5060",error:""},
      {shiptoParty: "2050000002", material: "1489731", serialNumber: "456", serialNumberQty: 1, invoiceNumber: "5223551779", itemId:"1489731",correctShipToParty: "",errorCode:"5061",error:""},
      {shiptoParty: "2050000002", material: "1489731", serialNumber: "789", serialNumberQty: 4, invoiceNumber: "5223551779", itemId:"1489731",correctShipToParty: "",errorCode:"9006",error:""},
 


      {shiptoParty: "2050000002", material: "3708997", serialNumber: "1234", serialNumberQty: 1, invoiceNumber: "6223551779", itemId:"3708997",correctShipToParty: "",errorCode:"0",error:""},
      {shiptoParty: "2050000002", material: "3708997", serialNumber: "4564", serialNumberQty: 1, invoiceNumber: "6223551779", itemId:"3708997",correctShipToParty: "",errorCode:"0",error:""},
      {shiptoParty: "2050000002", material: "3708997", serialNumber: "7897", serialNumberQty: 2, invoiceNumber: "6223551779", itemId:"3708997",correctShipToParty: "",errorCode:"0",error:""},
      {shiptoParty: "2050000002", material: "3708997", serialNumber: "3213", serialNumberQty: 3, invoiceNumber: "6223551779", itemId:"3708997",correctShipToParty: "",errorCode:"0",error:""},
 
      {shiptoParty: "2050000002", material: "3708997", serialNumber: "12345", serialNumberQty: 4, invoiceNumber: "7224485166", itemId:"3708997",correctShipToParty: "",errorCode:"0",error:""},
      {shiptoParty: "2050000002", material: "3708997", serialNumber: "45645", serialNumberQty: 1, invoiceNumber: "7224485166", itemId:"3708997",correctShipToParty: "",errorCode:"0",error:""},
      {shiptoParty: "2050000002", material: "3708997", serialNumber: "78975", serialNumberQty: 1, invoiceNumber: "7224485166", itemId:"3708997",correctShipToParty: "",errorCode:"0",error:""},
      {shiptoParty: "2050000002", material: "3708997", serialNumber: "32135", serialNumberQty: 3, invoiceNumber: "7224485166", itemId:"3708997",correctShipToParty: "",errorCode:"0",error:""},
 

 
      {shiptoParty: "2050000002", material: "4032561", serialNumber: "1421", serialNumberQty: 1, invoiceNumber: "8223551779", itemId:"4032561",correctShipToParty: "",errorCode:"9001",error:""},
      {shiptoParty: "2050000002", material: "4032561", serialNumber: "1422", serialNumberQty: 1, invoiceNumber: "8223551779", itemId:"4032561",correctShipToParty: "",errorCode:"9005",error:""},
      {shiptoParty: "2050000002", material: "4032561", serialNumber: "1423", serialNumberQty: 1, invoiceNumber: "8223551779", itemId:"4032561",correctShipToParty: "" ,errorCode:"0",error:""},
      {shiptoParty: "2050000002", material: "4032561", serialNumber: "1424", serialNumberQty: 1, invoiceNumber: "8223551779",itemId:"4032561", correctShipToParty: "",errorCode:"0",error:""},
      {shiptoParty: "2050000002", material: "4032561", serialNumber: "1425", serialNumberQty: 1, invoiceNumber: "8223551779",itemId:"4032561", correctShipToParty: "",errorCode:"0",error:""},
      {shiptoParty: "2050000002", material: "4032561", serialNumber: "1426", serialNumberQty: 1, invoiceNumber: "8223551779",itemId:"4032561", correctShipToParty: "",errorCode:"0",error:""},
 
      {shiptoParty: "2050000002", material: "4032561", serialNumber: "14215", serialNumberQty: 1, invoiceNumber: "9223551779", itemId:"4032561",correctShipToParty: "",errorCode:"9001",error:""},
      {shiptoParty: "2050000002", material: "4032561", serialNumber: "14225", serialNumberQty: 1, invoiceNumber: "9223551779", itemId:"4032561",correctShipToParty: "",errorCode:"9005",error:""},
      {shiptoParty: "2050000002", material: "4032561", serialNumber: "14235", serialNumberQty: 1, invoiceNumber: "9223551779", itemId:"4032561",correctShipToParty: "" ,errorCode:"0",error:""},
      {shiptoParty: "2050000002", material: "4032561", serialNumber: "14245", serialNumberQty: 1, invoiceNumber: "9223551779",itemId:"4032561", correctShipToParty: "",errorCode:"0",error:""},
      {shiptoParty: "2050000002", material: "4032561", serialNumber: "14255", serialNumberQty: 1, invoiceNumber: "9223551779",itemId:"4032561", correctShipToParty: "",errorCode:"0",error:""},
      {shiptoParty: "2050000002", material: "4032561", serialNumber: "14265", serialNumberQty: 1, invoiceNumber: "9223551779",itemId:"4032561", correctShipToParty: "",errorCode:"0",error:""}
 
      //non serialized - 1000069
      //non returnable - 1020700
        
    ]
 
    const matchingSerialIndex = mockData.findIndex((result)=>result.serialNumber === serialNumberRequest)
 
 
    if(matchingSerialIndex != -1){
      return mockData[matchingSerialIndex];
    }
   
     return api1Response = {
       error: "Invalid Serial Number",
       errorCode: "5021"
     }
     
  }
}


export class invoicePay {
  ccInvoiceList: any[];
  creditCard: any;
  customer: string;
}